import { percent, rem } from "csx";
import { Content, Horizontal, StretchSpacer, Vertical } from "gls/lib";
import { ReactElement } from "react";
import { style } from "typestyle";
import { Colours, Sizes, fontFamily } from "../../styles";
import { InputErrors } from "./InputErrors";
import { InputLabel } from "./InputLabel";

interface InputLayoutProps {
  label?: string | ReactElement;
  labelPosition?: "top" | "left" | "right";
  required?: boolean;
  errors?: string[];
  value?: string | null;
  counter?: boolean;
  maxLength?: number;
  hideErrors?: boolean;
  withSpacer?: boolean;
  size?: "sm" | "md";
  fullHeight?: boolean;
  fullWidth?: boolean;
  htmlFor?: string;
}

export const InputLayout: FCWithChildren<InputLayoutProps> = ({
  children,
  label,
  labelPosition = "top",
  required,
  errors,
  value,
  counter,
  maxLength,
  hideErrors,
  withSpacer = true,
  size = "md",
  fullHeight,
  fullWidth,
  htmlFor,
}) => {
  return (
    <Vertical
      width={percent(100)}
      spacing={rem(0.25)}
      sizing="stretch"
      className={style({
        alignSelf: "stretch",
      })}
    >
      {(labelPosition === "top" || (counter && maxLength)) && (
        <Horizontal spacing={0}>
          {labelPosition === "top" && (
            <InputLabel
              label={label}
              isRequired={required}
              size={size}
              htmlFor={htmlFor}
            />
          )}
          {counter && maxLength && (
            <>
              <StretchSpacer />
              <Content
                className={style({
                  fontFamily: fontFamily,
                  color: Colours.textDark,
                  fontSize: Sizes.fontSize1,
                })}
              >
                {value?.length || 0} / {maxLength}
              </Content>
            </>
          )}
        </Horizontal>
      )}

      <Horizontal
        spacing={rem(0.5)}
        verticalAlign="center"
        padding={
          labelPosition !== "top" && withSpacer
            ? [rem((fullHeight && 1) || 0), 0, 0, 0]
            : undefined
        }
      >
        {labelPosition === "left" && (
          <>
            <InputLabel
              label={label}
              isRequired={required}
              size={size}
              htmlFor={htmlFor}
            />
            {fullWidth && <StretchSpacer />}
          </>
        )}

        {children}

        {labelPosition === "right" && (
          <>
            {fullWidth && <StretchSpacer />}
            <InputLabel
              label={label}
              isRequired={required}
              size={size}
              htmlFor={htmlFor}
            />
          </>
        )}
      </Horizontal>
      {!hideErrors && <InputErrors errors={errors} />}
    </Vertical>
  );
};
